// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"72":"5bae6d7e","170":"fe6faeec","481":"a7558cbc"}[chunkId] + ".chunk.css");